module.exports = __webpack_public_path__ + "img/3@2x.fcdc6d2d.png";